import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-component" }
const _hoisted_2 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_3 = { class: "p-field p-input-filled p-col-12" }
const _hoisted_4 = { for: "batchClass" }
const _hoisted_5 = { class: "p-field p-input-filled p-col-12" }
const _hoisted_6 = { for: "classifications" }
const _hoisted_7 = { class: "p-field p-col-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_FileUpload = _resolveComponent("FileUpload")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.$t('Squeeze.BatchClasses.BatchClass')) + " *", 1),
        _createVNode(_component_Dropdown, {
          id: "batchClass",
          modelValue: _ctx.activeBatchClass,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeBatchClass) = $event)),
          options: _ctx.batchClasses,
          optionValue: "id",
          optionLabel: _ctx.getTranslatedDescription,
          placeholder: _ctx.$t('Squeeze.BatchClasses.PleaseSelect'),
          loading: _ctx.loadingBatchClasses,
          onChange: _ctx.getBatchClassClassifications
        }, null, 8, ["modelValue", "options", "optionLabel", "placeholder", "loading", "onChange"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("label", _hoisted_6, [
          _createTextVNode(_toDisplayString(_ctx.$t('Squeeze.DocumentClasses.DocumentClass')) + " ", 1),
          _cache[2] || (_cache[2] = _createElementVNode("small", null, "(optional)", -1))
        ]),
        _createVNode(_component_Dropdown, {
          id: "classifications",
          modelValue: _ctx.activeDocumentClass,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.activeDocumentClass) = $event)),
          options: _ctx.classifications,
          optionValue: "documentClassId",
          optionLabel: _ctx.getTranslatedDescription,
          placeholder: _ctx.$t('Squeeze.DocumentClasses.PleaseSelect'),
          showClear: true,
          loading: _ctx.loadingClassifications
        }, null, 8, ["modelValue", "options", "optionLabel", "placeholder", "loading"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_FileUpload, {
          onSelect: _ctx.onSelectFiles,
          name: "documentFile",
          customUpload: true,
          onUploader: _ctx.fileUploader,
          multiple: true,
          maxFileSize: 100000000,
          showCancelButton: true,
          uploadFiles: _ctx.files,
          cancelLabel: _ctx.$t('Squeeze.General.Clear'),
          chooseLabel: _ctx.$t('Squeeze.General.Choose'),
          customProgress: _ctx.progress,
          fileContentHeight: '15.625rem',
          uploadLabel: _ctx.uploadLabel,
          onClear: _ctx.clearFiles,
          onRemoveFile: _ctx.removeFile,
          invalidFileSizeMessage: '{0}: ' + _ctx.$t('Squeeze.Validation.General.InvalidFileSize') + ' ' + '{1}'
        }, null, 8, ["onSelect", "onUploader", "uploadFiles", "cancelLabel", "chooseLabel", "customProgress", "uploadLabel", "onClear", "onRemoveFile", "invalidFileSizeMessage"])
      ])
    ])
  ]))
}